module.exports = "data:image/gif;base64,R0lGODlhEAAOAIIAAZdaH+C6eP/inq1zLf/////Sg59oJMOHNCwAAAAAEAAOAAIDN0i63P7vyAPXYBcewUsIk8RQFalsXKoCmDq8cEwMKa2mxWUUOe//GUDvB1wABsQiw8BsOitQQgIAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/treeview/folder.gif
// module id = 1971
// module chunks = 2